<template>
  <v-app class="progress-app">
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col cols="auto" class="text-center">
            <v-img
              v-if="logoSrc"
              contain
              max-width="200"
              max-height="60"
              :src="logoSrc"
              class="progress-logo mb-6"
              @error="onLogoError"
            />
            <div v-else class="progress-brand mb-6">{{ appName }}</div>
            <v-progress-linear
              indeterminate
              color="primary"
              height="3"
              class="progress-bar mb-4"
            />
            <div class="progress-text">กำลังเชื่อมต่อระบบ...</div>
            <div class="progress-subtext">{{ appTagline }}</div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getPersistedLogo } from '@/utils/tenantBranding'
import { APP_NAME, APP_TAGLINE_TH } from '@/config/appBrand'

export default {
  data() {
    return {
      logoError: false,
      logoSrc: getPersistedLogo(),
      appName: APP_NAME,
      appTagline: APP_TAGLINE_TH,
    }
  },
  methods: {
    onLogoError() {
      this.logoError = true
      this.logoSrc = null
    },
  },
}
</script>

<style scoped>
.progress-app {
  background: var(--chrome-dark, #1C1F26) !important;
}

.progress-logo {
  margin: 0 auto;
}

.progress-brand {
  font-size: 1.25rem;
  font-weight: 600;
  color: #E5E7EB;
  letter-spacing: 0.02em;
}

.progress-bar {
  max-width: 240px;
  margin: 0 auto;
}

.progress-text {
  font-size: 0.95rem;
  font-weight: 500;
  color: #E5E7EB;
}

.progress-subtext {
  font-size: 0.75rem;
  color: rgba(229, 231, 235, 0.45);
  margin-top: 4px;
  letter-spacing: 0.02em;
}
</style>
